export default __webpack_public_path__ + "static/FS2S-InHub-115-9e59ac7b047bbf9ca64116856bb1d5da.jpg";